import { TILE_TERRAIN_IDS, type WorldBalance } from "@dawn/engine";
import type { CoreBalance } from "./balance/coreBalance.ts";

/** Host `CoreBalance` (including override.json) → engine reduce balance. */
export function toWorldBalance(core: CoreBalance): WorldBalance {
  const terrainFoodProduction = {} as WorldBalance["terrainFoodProduction"];
  for (const terrain of TILE_TERRAIN_IDS) {
    terrainFoodProduction[terrain] = core.terrainFoodProduction[terrain];
  }

  return {
    initialPopulation: core.initialPopulation,
    initialFoodSupplies: core.initialFoodSupplies,
    initialTurn: core.initialTurn,
    victoryPopulation: core.victoryPopulation,
    defeatPopulation: core.defeatPopulation,
    foodBankGrowthThreshold: core.foodBankGrowthThreshold,
    foodBankGrowthCost: core.foodBankGrowthCost,
    growthStreakRequired: core.growthStreakRequired,
    famineStreakRequired: core.famineStreakRequired,
    tileFoodDepletionStep: core.tileFoodDepletionStep,
    tileFoodRegenStep: core.tileFoodRegenStep,
    tileFoodMinYieldFraction: core.tileFoodMinYieldFraction,
    terrainFoodProduction,
    terrainSpawnWeights: core.terrainSpawnWeights.map(({ terrain, weight }) => ({
      terrain,
      weight,
    })),
    fireEventProbability: core.fireEventProbability,
    fireDurationTurnsMin: core.fireDurationTurnsMin,
    fireDurationTurnsMax: core.fireDurationTurnsMax,
  };
}
